import apiClient from "@shared/services/apiClient";
import {
  EventCatalogItem,
  EventSet,
  LabelSystemSummary,
  TrendTemplate,
} from "../types/eegConfig.types";
async function getConfigRows<T>(path: string): Promise<T[]> {
  const response = await apiClient.get(path);
  const data = (response.data as any)?.data ?? response.data;
  if (!Array.isArray(data)) throw new Error(`Invalid EEG configuration response: ${path}`);
  return data as T[];
}

export async function fetchEventCatalog(): Promise<EventCatalogItem[]> {
  return getConfigRows<EventCatalogItem>("/eeg/config/event-catalog");
}

async function putConfigRows<T>(path: string, rows: T[]): Promise<T[]> {
  const response = await apiClient.put(path, { data: rows });
  const data = (response.data as any)?.data ?? response.data;
  if (!Array.isArray(data)) throw new Error(`Invalid EEG configuration response: ${path}`);
  return data as T[];
}

export async function saveEventCatalog(
  rows: EventCatalogItem[],
): Promise<EventCatalogItem[]> {
  return putConfigRows("/eeg/config/event-catalog", rows);
}

export async function fetchEventSets(): Promise<EventSet[]> {
  return getConfigRows<EventSet>("/eeg/config/event-sets");
}

export async function saveEventSets(
  rows: EventSet[],
): Promise<EventSet[]> {
  return putConfigRows("/eeg/config/event-sets", rows);
}

export async function saveEventCatalogBundle(eventSets: EventSet[], events: EventCatalogItem[]): Promise<{ eventSets: EventSet[]; events: EventCatalogItem[] }> {
  const response = await apiClient.put("/eeg/config/catalog-bundle", { eventSets, events });
  const data = (response.data as any)?.data;
  if (!Array.isArray(data?.eventSets) || !Array.isArray(data?.events)) throw new Error("Invalid event catalog save response");
  return data;
}

export async function fetchTrendTemplates(): Promise<TrendTemplate[]> {
  return getConfigRows<TrendTemplate>("/eeg/config/trend-templates");
}

export async function saveTrendTemplates(
  rows: TrendTemplate[],
): Promise<TrendTemplate[]> {
  return putConfigRows("/eeg/config/trend-templates", rows);
}

export async function fetchLabelSystems(): Promise<LabelSystemSummary[]> {
  const systems = await getConfigRows<{
    system_id: string;
    system_name: string;
    description?: string;
    is_standard?: boolean;
  }>("/eeg/channels/systems");
  return systems.map((system) => ({
    id: system.system_id,
    name: system.system_name,
    description: system.description,
    isSystem: Boolean(system.is_standard),
  }));
}
